

export class LogMapper {
  static specialty = ''
  static columns = []
  static components = {}
  static registeredMappers = {}

  static registerMapper(mapper){
    this.registeredMappers[mapper.specialty] = mapper
  }

  static standardOptions(component) {
    return component.options
  }

  static getTextFieldOptions(component, logs) {
    const options = []
    logs.forEach(log => {
      if (log[component.id]) {
        options.push({ text: log[component.id], value: log[component.id] })
      }
    });
    return options
  }

  static getOptions(component, logs) {
    if (!component) {
      return []
    }
    const id = (component || {}).id
    if (this.components[id]) {
      return this.components[id].options(component, logs)
    }
    if (['text-field', 'hint-field'].includes(component.type)) {
      return this.getTextFieldOptions(component, logs)
    }
    
    // Dedupe options as some options in Scientific and training activity are similar and become repeated
    // National and International are the problematic ones
    const options = component.options || []
    const dedupedOptions = []
    options.forEach( opt => {
      if (!dedupedOptions.some( o => o.value == opt.value )){
        dedupedOptions.push(opt)
      }
    } )
    return dedupedOptions
  }

  static basicChecker(log, componentId, option) {
    return log[componentId] !== undefined && log[componentId] === option.value
  }

  static inArrayChecker(log, componentId, option) {
    return Array.isArray(log[componentId]) && log[componentId].includes(option.value)
  }

  static checker(log, componentId, option) {
    const logValue = log[componentId]
    if (typeof logValue === 'string') {
      return log[componentId] === option.value
    } else if (Array.isArray(logValue)) {
      return log[componentId].includes(option.value)
    } else {
      return false
    }
  }
}

export const allComponent = {
  options: () => ([]),
  checker: () => {
    true
  }
}

export function mappingResults(r) {
  return {
    text: r.label,
    value: r.id
  }
}
